import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  TextField,
  MenuItem,
  Typography,
  CircularProgress,
  Card,
  CardContent,
} from "@mui/material";
import axiosInstance from "../common/axios"; // adjust path or replace with axios
const backendUrl = process.env.REACT_APP_BACKEND_URL;

const AssignOrderToShipper = () => {
  const [orders, setOrders] = useState([]);
  const [shippers, setShippers] = useState([]);
  const [selectedOrder, setSelectedOrder] = useState("");
  const [selectedShipper, setSelectedShipper] = useState("");
  const [orderDetails, setOrderDetails] = useState(null);
  const [shipperDetails, setShipperDetails] = useState(null);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);

  // 🔹 Fetch available orders and shippers
  useEffect(() => {
    fetchOrders();
    fetchShippers();
  }, []);

  const fetchOrders = async () => {
    try {
      const res = await axiosInstance.get(`${backendUrl}/api/orders`);
      setOrders(res.data.content);
    } catch (err) {
      console.error("Error fetching orders", err);
    }
  };

  const fetchShippers = async () => {
    try {
      const res = await axiosInstance.get(`${backendUrl}/api/shippers`);
      setShippers(res.data);
    } catch (err) {
      console.error("Error fetching shippers", err);
    }
  };

  // 🔹 Load order and shipper details dynamically
  useEffect(() => {
    if (selectedOrder) fetchOrderDetails(selectedOrder);
  }, [selectedOrder]);

  useEffect(() => {
    if (selectedShipper) fetchShipperDetails(selectedShipper);
  }, [selectedShipper]);

  const fetchOrderDetails = async (orderId) => {
    try {
    //  const res = await axiosInstance.get(`${backendUrl}/api/orders/${orderId}`);
    //  setOrderDetails(res.data);
        const selectedOrder = orders.find((o) => o.orderId === orderId);
setOrderDetails(selectedOrder);
    } catch (err) {
      console.error("Error fetching order details", err);
    }
  };

  const fetchShipperDetails = async (shipperId) => {
    try {
     // const res = await axiosInstance.get(`${backendUrl}/api/shippers/${shipperId}`);
    //  setShipperDetails(res.data);
                const selectedShipper = shippers.find((s) => s.id === shipperId);
                setShipperDetails(selectedShipper);
    } catch (err) { 
      console.error("Error fetching shipper details", err);
    }
  };

  // 🔹 Submit assignment
  const handleSubmit = async () => {
    if (!selectedOrder || !selectedShipper) {
      alert("Please select both order and shipper");
      return;
    }
    setLoading(true);
    try {
      await axiosInstance.post(`${backendUrl}/api/shipperrequest/create`, {
        orderId: selectedOrder,
        shipperId: selectedShipper,
      });
      alert("Order successfully assigned!");
      handleClose();
      fetchOrders();
    } catch (err) {
      console.error("Error assigning order", err);
      alert("Failed to assign order");
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedOrder("");
    setSelectedShipper("");
    setOrderDetails(null);
    setShipperDetails(null);
  };

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h5" sx={{ mb: 2 }}>
        Assign Order to Shipper
      </Typography>

      <Button variant="contained" color="primary" onClick={() => setOpen(true)}>
        Assign Order
      </Button>

      <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
        <DialogTitle>Assign Order to Shipper</DialogTitle>
        <DialogContent>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid item xs={12} sm={6}>
              <TextField
                select
                fullWidth
                label="Select Order"
                value={selectedOrder}
                onChange={(e) => setSelectedOrder(e.target.value)}
              >
                {orders.map((o) => (
                  <MenuItem key={o.orderId} value={o.orderId}>
                    #{o.orderId} - {o.userName} - {o.shippingAddress.postalCode}-  ₹{o.grandTotal?.toFixed(2)}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                select
                fullWidth
                label="Select Shipper"
                value={selectedShipper}
                onChange={(e) => setSelectedShipper(e.target.value)}
              >
                {shippers.map((s) => (
                  <MenuItem key={s.id} value={s.id}>
                      {s.homeZones
                        ?.map((z) => z.name)
                        .join(", ") || "N/A"} {s.name} ({s.contactNumber})
                  </MenuItem>
                ))}
              </TextField>
            </Grid>

            {/* Order Details */}
            {orderDetails && (
              <Grid item xs={12}>
                <Card variant="outlined" sx={{ mt: 2 }}>
                  <CardContent>
                    <Typography variant="h6">Order Details</Typography>
                    <Typography>ID: {orderDetails.orderId}</Typography>
                    <Typography>Customer: {orderDetails.userName}</Typography>
                    <Typography>Address: {orderDetails.shippingAddress.postalCode}</Typography>
                    <Typography>Status: {orderDetails.orderStatus}</Typography>
                    <Typography>
                      Total: ₹{orderDetails.totalAmount?.toFixed(2)}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            )}

            {/* Shipper Details */}
            {shipperDetails && (
              <Grid item xs={12}>
                <Card variant="outlined" sx={{ mt: 2 }}>
                  <CardContent>
                    <Typography variant="h6">Shipper Details</Typography>
                    <Typography>Name: {shipperDetails.name}</Typography>
                    <Typography>Email: {shipperDetails.email}</Typography>
                    <Typography>Phone: {shipperDetails.contactNumber}</Typography>
                    <Typography>Vehicle: {shipperDetails.vehicleType}</Typography>
                    <Typography>
                      Zones:{" "}
                      {shipperDetails.homeZones
                        ?.map((z) => z.name)
                        .join(", ") || "N/A"}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            )}
          </Grid>
        </DialogContent>

        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button
            onClick={handleSubmit}
            variant="contained"
            color="primary"
            disabled={loading}
          >
            {loading ? <CircularProgress size={22} /> : "Assign"}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default AssignOrderToShipper;